import React from "react";
import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";

const UsernameInput = (props) => {
  const { control, getValues } = props.formController;
  return (
    <Controller
      name="username"
      control={control}
      defaultValue=""
      rules={{
        required: "Username is required.",
        message: "Username is required.",
        // validate: () => {
        //   if(Validate.email(getValues('username'))) return true;
        //   return 'Must be a valid email address.';
        // }
      }}
      render={({ field, fieldState }) => {
        return (
          <>
            <TextField
              label={props.label}
              type="email"
              autoComplete="username"
              required={true}
              error={fieldState.error !== undefined}
              helperText={fieldState.error ? "Username is required." : ""}
              // {...(props.register
              //   ? { ...props.register("username", { required: true }) }
              //   : null)}
              {...field}
            />
          </>
        );
      }}
    />
  );
};

export default UsernameInput;
